import { useMemo } from 'react'
import { getSSOClientConfig } from '../config'

export function useSSOClientConfig() {
  const config = useMemo(() => getSSOClientConfig(), [])
  return useMemo(
    () => ({
      config,
      isPresetOrg: !!(config?.orgId && config?.clinicId),
      isPrescriberOnly: !!config?.prescriberOnly,
      hasFixedOrganization: !!config?.orgId,
      requiresJoinRequestApproval: !!config?.requiresJoinRequestApproval,
      forcePhoneNumber: config?.forcePhoneNumber,
    }),
    [config]
  )
}
